import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, HeadphonesIcon, PresentationIcon, SparklesIcon } from 'lucide-react';
const productShowcase = 'https://cdn.magicpatterns.com/uploads/kXrmTu5ZHBsUMJ3odGM5uo/CB6DAA16-723A-400F-AB8A-E8D7B9F18E21.png';
export function FinalOffer() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = [{
    icon: BookOpenIcon,
    count: '3',
    label: 'eBooks'
  }, {
    icon: HeadphonesIcon,
    count: '3',
    label: 'Audiolibros'
  }, {
    icon: PresentationIcon,
    count: '3',
    label: 'Presentaciones'
  }];
  return <section ref={ref} id="oferta" className="py-24 md:py-32 px-4 relative overflow-hidden" data-id="element-1">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#141414] to-[#0a0a0a]" data-id="element-2" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#D4AF37]/5 via-transparent to-transparent" data-id="element-3" />

      <div className="relative z-10 max-w-5xl mx-auto" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-5">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="inline-flex items-center gap-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full px-5 py-2 mb-8" data-id="element-6">
            <SparklesIcon className="w-5 h-5 text-[#D4AF37]" data-id="element-7" />
            <span className="text-[#D4AF37] font-medium" data-id="element-8">Oferta Especial</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-9">
            Llévate los{' '}
            <span className="text-[#D4AF37]" data-id="element-10">
              3 eBooks, 3 audiolibros y 3 presentaciones visuales
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-xl text-gray-300 max-w-2xl mx-auto mb-12" data-id="element-11">
            Dominarás la historia reciente de Venezuela de forma neutral,
            profunda y práctica.
          </motion.p>

          {/* Feature counts */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="flex justify-center gap-8 md:gap-16 mb-12" data-id="element-12">
            {features.map((feature, index) => <motion.div key={feature.label} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.4,
            delay: 0.6 + index * 0.1
          }} className="flex flex-col items-center" data-id="element-13">
                <div className="w-16 h-16 rounded-full bg-[#D4AF37]/10 flex items-center justify-center mb-3" data-id="element-14">
                  <feature.icon className="w-8 h-8 text-[#D4AF37]" data-id="element-15" />
                </div>
                <span className="font-display text-3xl font-bold text-white" data-id="element-16">
                  {feature.count}
                </span>
                <span className="text-gray-400" data-id="element-17">{feature.label}</span>
              </motion.div>)}
          </motion.div>

          {/* Product image */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="max-w-3xl mx-auto mb-12" data-id="element-18">
            <img src={productShowcase} alt="Colección completa: eBooks, audiolibros y presentaciones" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-19" />
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.9
        }} className="space-y-6" data-id="element-20">
            {/* Pricing */}
            <div className="flex items-center justify-center gap-4" data-id="element-21">
              <span className="text-2xl text-gray-500 line-through" data-id="element-22">
                59,95€
              </span>
              <span className="text-5xl md:text-6xl font-bold text-[#D4AF37]" data-id="element-23">
                19,95€
              </span>
            </div>
            <p className="text-gray-400 text-lg" data-id="element-24">
              Ahorra más del 65% • Oferta por tiempo limitado
            </p>

            <motion.a id="cta-button" href="https://pay.hotmart.com/Y104015139E" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-[#D4AF37] text-black font-bold px-12 py-5 text-xl rounded-sm hover:bg-[#E5C158] transition-colors shadow-lg shadow-[#D4AF37]/20" data-id="element-25">
              Adquiere el Pack Completo Ahora
            </motion.a>

            <p className="mt-6 text-gray-500 text-sm" data-id="element-26">
              Acceso inmediato • Descarga digital • Sin suscripción
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}